import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSignal = signal<boolean>(false);

  isLoading(): boolean {
    return this.loadingSignal();
  }

  setLoading(loading: boolean): void {
    this.loadingSignal.set(loading);
  }
}
